export default "__VITE_ASSET__BxKXOGqh__"